import {Component, OnInit, ViewChild} from '@angular/core';
import {faPlus, faSearch} from '@fortawesome/free-solid-svg-icons';
import {EditService} from '../shared/services/editService/edit.service';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {Races} from './Races';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {Race} from '../shared/classes/Race';
import {SearchInputComponent} from '../search-input/search-input.component';

@Component({
  selector: 'app-races',
  templateUrl: './races.component.html',
  styleUrls: ['./races.component.css'],
  providers: [DatePipe]
})
export class RacesComponent implements OnInit {

  private _races = undefined;
  private _timeFiltered = undefined;
  private _filteredRace = undefined;
  faPlus = faPlus;
  faSearch = faSearch;
  showSearch = false;
  timeSelect = 'all';


  get races(): any {
    return this._races;
  }

  get filteredRace(): any[] {
    return this._filteredRace;
  }

  get timeFiltered(): any[] {
    return this._timeFiltered;
  }

  set timeFiltered(value: any[]) {
    this._timeFiltered = value;
  }

  displayedColumns: string[] = ['dateStart', 'name', 'location' , 'sportType'];

  header = [
    {
      defName: 'name',
      translation: 'racesPage.racesTab.name',
      elem: 'name'
    },
    {
      defName: 'location',
      translation: 'racesPage.racesTab.location',
      elem: 'location'
    },
    {
      defName: 'dateStart',
      translation: 'racesPage.racesTab.date',
      elem: 'dateStart'
    },
    {
      defName: 'sportType',
      translation: 'racesPage.racesTab.sport',
      elem: 'sportType'
    }
  ];

  constructor(private editService: EditService,
              private racesService: RacesService,
              private datePipe: DatePipe,
              private router: Router) { }

  ngOnInit() {
    this.racesService.getRaces().then( data => {
      const races = [];
      data.forEach( item => {

        item.data().sportType.get().then( type => {
          const race: Race = new Race();
          race.id = item.id;
          race.name = item.data().name;
          race.dateStart =  this.datePipe.transform(item.data().dateStart.toDate(), 'dd.MM.yyyy');
          race.dateFinish =  this.datePipe.transform(item.data().dateFinish.toDate(), 'dd.MM.yyyy');
          race.location = item.data().location;
          race.sportType = type.data().type;
          races.push(race);
        });
      });
      setTimeout(() => {
        this._races = races;
        this._filteredRace = this.races;
      }, 400);
    });
  }

  create() {
    this.router.navigate(['/admin/races/info', 'new']);
  }

  edit(item) {
    this.router.navigate(['/admin/races/info', item.id]);
  }

  loadData(races) {
    this._filteredRace = races;
  }

  search() {
    this.showSearch = !this.showSearch;
  }

  isEdit(){
    return this.editService.editable;
  }

}
